import { Dispatch, FC, useState } from "react";
import { Backdrop, Box, Button, CircularProgress, FormControl, InputLabel, Select } from "@mui/material";
import { useStyles } from "../styles";
import { DataRef } from "../../../types/DataRef";
import { AxiosInstance } from "axios";
import CheckAttr from "../../../utils/CheckAttr";
import UpdateIcon from '@mui/icons-material/Update';
import { AlertType } from "../../../types/AlertType";

type societeType = number | null;

interface UpdateCodeGescoFormProps {
    dataSocieteFacturations: DataRef[];
    http: AxiosInstance;
    setOpenSnack: Dispatch<React.SetStateAction<boolean>>;
    setAlerteMessage: Dispatch<React.SetStateAction<string>>;
    setAlertType: Dispatch<React.SetStateAction<AlertType>>;
    onClose: () => void;
}

const UpdateCodeGescoForm: FC<UpdateCodeGescoFormProps> = ({
    dataSocieteFacturations,
    http,
    setOpenSnack,
    setAlerteMessage,
    setAlertType,
    onClose
}) => {
    const classes = useStyles();

    const [isClickUpdate, setIsClickUpdate] = useState<boolean>(false);
    const [societeFacturation, setSocieteFacturation] = useState<societeType>(null);

    const handleUpdate = () => {
        setIsClickUpdate(true);
        http.post('/update-code-gesco-for-manual-use', { societeFacturation })
            .then(res => {
                const { status, message } = res.data;

                if (status) {
                    setAlerteMessage("Mis à jour code gesco éffectué !");
                    setAlertType("success");
                    setOpenSnack(true);
                } else {
                    setAlerteMessage(message);
                    setAlertType("warning");
                    setOpenSnack(true);
                }
            }).catch(error => {
                console.log(error);
                setAlertType("error");
                setOpenSnack(true);
            }).finally(() => {
                setIsClickUpdate(false);
            });
    };

    const handleChange = (e: any) => {
        if (e.target.value != "") {
            setSocieteFacturation(e.target.value as number);
        } else {
            setSocieteFacturation(null);
        }
    }

    return (
        <Box className={classes.root}>
            <form>
                <FormControl
                    variant="outlined"
                    className={classes.formControl}
                >
                    <InputLabel
                        htmlFor="societeFacturation"
                        color="warning"
                        shrink={CheckAttr(societeFacturation)}
                    >
                        Société de facturation
                    </InputLabel>
                    <Select
                        id="societeFacturation"
                        native
                        color="warning"
                        value={societeFacturation}
                        onChange={handleChange}
                        label="Société de facturation"
                    >
                        <option value=""></option>
                        {dataSocieteFacturations.map((societe) => (
                            <option key={societe?.id} value={societe?.id}>
                                {societe?.libelle}
                            </option>
                        ))}
                    </Select>
                </FormControl>
            </form>

            <Box display="flex" justifyContent="center" mt={5}>
                <Button
                    variant="contained"
                    color="warning"
                    sx={{ textTransform: "none" }}
                    endIcon={<UpdateIcon />}
                    onClick={() => handleUpdate()}
                >
                    Importer code gesco
                </Button>
            </Box>

            <div>
                <Backdrop
                    sx={{ color: "white", zIndex: (theme) => theme.zIndex.drawer + 1 }}
                    open={isClickUpdate}
                >
                    <CircularProgress color="inherit" />
                </Backdrop>
            </div>
        </Box>
    );
};

export default UpdateCodeGescoForm;